<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/custom/parameter/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('canshumingcheng')">
            <yi_dictionary_select :type="'CUSTOMER_PARAMETER'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          v-if="utils.checkPower('web_system_param_create')"
          @click="
            yt.showEditDialog('xinzeng', null, 'w2');
            getEquipmentList();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 自定义某个字段 -->

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              type="text"
              v-if="utils.checkPower('web_system_param_update')"
              @click="
                yt.showEditDialog('bianji', scope.row, 'w2');
                getEquipmentList();
              "
              >{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_system_param_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/config/custom/parameter/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- <template #beizhu="scope">
				{{scope.row.remark==null?'-':scope.row.remark}}
			</template> -->
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini">
          <el-form-item :label="$t('canshumingcheng')" required label-width="130px">
            <yi_dictionary_select :type="'CUSTOMER_PARAMETER'" :ids.sync="yt.editObj.type"> </yi_dictionary_select> </el-form-item
          ><br />
          <el-form-item :label="$t('beizhu')" label-width="130px">
            <el-input style="width: 200px;" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: center;">
          <el-transfer :titles="[this.$t('shebeiliebiao'), this.$t('yixuancanshuzhi')]" v-model="yt.editObj.equipmentIds" :data="equipmentList" :props="{ key: 'id', label: 'name' }"> </el-transfer>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/config/custom/parameter/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('canshumingcheng')" required label-width="130px">
            <yi_dictionary_select :type="'CUSTOMER_PARAMETER'" :ids.sync="yt.editObj.type" disabled> </yi_dictionary_select> </el-form-item
          ><br />
          <el-form-item :label="$t('beizhu')" label-width="130px">
            <el-input style="width: 200px;" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <div style="display: flex;justify-content: center;">
            <el-transfer :titles="[this.$t('shebeiliebiao'), this.$t('yixuancanshuzhi')]" v-model="yt.editObj.equipmentIds" :data="equipmentList" :props="{ key: 'id', label: 'name' }" :right-default-checked="yt.editObj.equipmentIds"></el-transfer>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/config/custom/parameter/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_system_param_list',
  data() {
    return {
      value: [],
      param: [],
      dictionaryList: [],
      equipmentList: [],
      timeFormatList: [
        {
          value: 'yyyyMMdd',
          label: 'yyyyMMdd'
        },
        {
          value: 'yyyyMM',
          label: 'yyyyMM'
        }
      ],
      status: [
        {
          label: this.$t('shi'),
          value: true
        },
        {
          label: this.$t('fou'),
          value: false
        }
      ],
      list: [],
      rolesList: [],
      organizationList: [],
      columns: [
        {
          label: 'canshumingcheng',
          type: 'dictionary',
          key: 'CUSTOMER_PARAMETER',
          prop: 'type',
          width: 300
        },
        {
          label: 'canshuzhi',
          prop: 'equipmentNames'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.getDictCatList();
    }, 300);
  },
  methods: {
    async getDictCatList() {
      let response = await this.http.get('/web/config/dictType/page', {
        params: {
          pageNum: 1,
          pageSize: 100
        }
      });
      this.dictionaryList = response.data.rows;
    },
    async getEquipmentList() {
      let response = await this.http.get('/web/equipment/standing_book/page', {
        params: {
          orderBy: 'sort asc',
          pageSize: 99999
        }
      });
      let rows = response.data.rows;
      for (var i = 0; i < rows.length; i++) {
        if (rows[i]['name'] == null) {
          rows[i]['name'] = ' ';
        }
      }
      this.equipmentList = rows;
    }
  }
};
</script>
